import React from "react";
import { inject, observer } from "mobx-react";
import { FieldRenderProps } from "react-final-form";
import { CommonsStore, PopupMessage } from "../../model/CommonsStore";
import { ToggleSwitchComponent } from "./ToggleSwitch";
import { I18n } from "../../model/I18n";
import { SecuredComponentProps } from "../Secured";

export interface ToggleSwitchState {
  switchValue: boolean;
}

export interface SwitchOptionsArray
  extends Array<{ label: string | (() => string); value: any }> {}

export interface SwitchFieldComponentProps extends FieldRenderProps<any> {
  columntitle: string;
  columnname: string;
  keyvalue: string;
  updateRows: (id: any, data: {}) => void;
  commons?: CommonsStore;
  options: SwitchOptionsArray;
  i18n: I18n;
}

@inject("commons", "i18n", "security")
@observer
export class SwitchFieldComponent extends React.Component<
  SwitchFieldComponentProps,
  ToggleSwitchState,
  SecuredComponentProps
> {
  public constructor(props: SwitchFieldComponentProps) {
    super(props);
    this.state = { switchValue: this.convertToBoolean(this.props.input.value) };
  }

  public componentDidUpdate() {
    const newValue = this.convertToBoolean(this.props.input.value);
    if (newValue != this.state.switchValue) {
      this.setState({ switchValue: newValue });
    }
  }

  private handleChange = (checked: boolean) => {
    const dialogMessage: PopupMessage = {
      title: this.props.i18n.t(
        "lego:field.switchField.dialogTitle",
        "Confirm Change"
      ),
      content:
        this.props.i18n.t(
          "lego:field.switchField.dialogQuestion",
          "Are you sure you want to change {{column}} to ",
          { column: this.props.columntitle }
        ) +
        this.getOptionLabel(this.convertFromBoolean(checked).label) +
        " ?"
    };
    this.props.commons!.showDialog(
      dialogMessage,
      this.switched(checked),
      this.canceled
    );
  };

  private convertToBoolean = (value: any) => {
    return this.props.options[0].value === value;
  };

  private convertFromBoolean = (value: boolean) => {
    if (value) {
      return this.props.options[0];
    } else {
      return this.props.options[1];
    }
  };

  private getOptionLabel = (label: string | (() => string)) => {
    return typeof label === "function" ? label() : label;
  };

  private switched = (checked: boolean) => () => {
    let dto = {};
    dto[this.props.columnname] = this.convertFromBoolean(checked).value;
    this.props.updateRows(this.props.keyvalue, dto);
    this.props.commons!.closeDialog();
  };

  private canceled = () => {
    this.props.commons!.closeDialog();
  };

  public render() {
    const { security, requiredAccess } = this.props;
    const finalRequiredAccess = requiredAccess || "editable";

    return (
      <ToggleSwitchComponent
        handleChange={this.handleChange}
        value={this.state.switchValue}
        disabled={!security || (security && !security[finalRequiredAccess]())}
      />
    );
  }
}
